// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Frame_frameRoot__L6L2F {
    display: flex;
    flex-direction: column;
    height: 100dvh;
    width: 100%;
    min-width: 0;
}
.Frame_layout__SlqJ9 {
    display: flex;
    flex: 1 1;
    width: 100%;
    min-height: 0; /* flex子のオーバーフロー回避 */
    min-width: 0;
}
.Frame_mainArea__2W39r {
    flex: 1 1;
    min-width: 0;
    padding: 16px;
    box-sizing: border-box;
    overflow: auto;
    background: var(--main-background, #f5f7fa);
}
`, "",{"version":3,"sources":["webpack://./src/Frame/Frame.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,cAAc;IACd,WAAW;IACX,YAAY;AAChB;AACA;IACI,aAAa;IACb,SAAO;IACP,WAAW;IACX,aAAa,EAAE,oBAAoB;IACnC,YAAY;AAChB;AACA;IACI,SAAO;IACP,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,cAAc;IACd,2CAA2C;AAC/C","sourcesContent":[".frameRoot {\r\n    display: flex;\r\n    flex-direction: column;\r\n    height: 100dvh;\r\n    width: 100%;\r\n    min-width: 0;\r\n}\r\n.layout {\r\n    display: flex;\r\n    flex: 1;\r\n    width: 100%;\r\n    min-height: 0; /* flex子のオーバーフロー回避 */\r\n    min-width: 0;\r\n}\r\n.mainArea {\r\n    flex: 1;\r\n    min-width: 0;\r\n    padding: 16px;\r\n    box-sizing: border-box;\r\n    overflow: auto;\r\n    background: var(--main-background, #f5f7fa);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"frameRoot": `Frame_frameRoot__L6L2F`,
	"layout": `Frame_layout__SlqJ9`,
	"mainArea": `Frame_mainArea__2W39r`
};
export default ___CSS_LOADER_EXPORT___;
